<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WsQX1M/images/9781540264534.jpg?1737821500135" alt="This image is the cover for the book Ghostly Tales of Amherst, New Hampshire, Spooky America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghostly Tales of Amherst, New Hampshire, Spooky America
      </h1>
      <p class="bookDescription body article font2">
        <p>Ghost stories from Amherst, New Hampshire have never been so creepy, fun, and full of mystery! <br/> Welcome to the spooky roads of Amherst, New Hampshire! <br/> Stay alert! Ghosts lurk around every corner. Even the most unexpected places might be haunted by wandering phantoms. <br/> Did you know Town Hall once had skeletons in the basement? Or that a haunted cottage sits near the shores of  Baboosic Lake ? Can you believe ghostly wolves roam the forests at night, their eerie howls echoing until dawn? <br/> Pulled right from history, these ghostly tales will change the way you see Amherst, New Hampshire forever, and have you sleeping with the lights on!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susanna Hargreaves
      </h2>
      
      <p class="authorDescription body article">Susanna Hargreaves is an educator and writer in her beloved town of Amherst, New Hampshire. Susanna and her husband have raised three children and four dogs on an old, haunted road. And, yes, she believes in ghosts.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ccec03da